import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
    Form as FormUi,
    Container, TextArea, Dropdown
} from "semantic-ui-react";
import { connect } from "react-redux";
import {
    successAlertDispatcher,
    errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import CreateAxios from "../../../components/axiosComponent/create";
import UpdateAxios from "../../../components/axiosComponent/update";
import { translate } from "react-i18next";
import { AllRegex } from "../../../utils/validation";
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import { LOCAL_STORAGE } from '../../../utils/constant'
import cogoToast from "cogo-toast";
import { FIELDS } from './bank_constants'
import MandatoryMark from "../../../components/common/mandatorymark";
import { MyNormalCheckBox } from "../../../components/dynamicComponent/myInputs";

const currentUser = LOCAL_STORAGE.customerNo

const InsertBank = ({ values, setFieldValue, touched, errors, t, ...props }) => {
    return (
        <React.Fragment>
            <Formiker>
                <div className="container-fluid animated slideInDown pad w3-white">
                    <div className="ml-3 mr-3 mt-5 mb-5 pl-3">
                        <div className="ui form">
                            <FormUi.Group inline>
                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.bank_code.title || "Bank Code"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field width={4} error={touched.bankCode && errors.bankCode ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input pe-5"
                                                name="bankCode"
                                                placeholder={FIELDS.bank_code.placeholder || "Enter bank Code"}
                                                disabled={props.editData.bankCode ? true : false}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.bankCode && errors.bankCode ? (
                                                <div className="error-msg">
                                                    {errors.bankCode}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                                <FormUi.Field width={1}></FormUi.Field>
                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.bank_name.title || "Bank Name"} <MandatoryMark />
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.bankName && errors.bankName ? true : false}>
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input"
                                                name="bankName"
                                                placeholder={FIELDS.bank_name.placeholder || "Enter Bank Name"}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.bankName && errors.bankName ? (
                                                <div className="error-msg">
                                                    {errors.bankName}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                            </FormUi.Group>

                            <FormUi.Group inline>
                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.account_code.title || "Account Code"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field width={4} error={touched.accountCode && errors.accountCode ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input"
                                                name="accountCode"
                                                placeholder={FIELDS.account_code.placeholder || "Enter Account Code"}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.accountCode && errors.accountCode ? (
                                                <div className="error-msg">
                                                    {errors.accountCode}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                                <FormUi.Field width={1}></FormUi.Field>

                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.account_name.title || "Account Name"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field width={4} error={touched.accountName && errors.accountName ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input"
                                                name="accountName"
                                                placeholder={FIELDS.account_name.placeholder || "Enter Account Name"}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.accountName && errors.accountName ? (
                                                <div className="error-msg">
                                                    {errors.accountName}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                            </FormUi.Group>

                            <FormUi.Group inline>
                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.account_no.title || "Account No"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field width={4} error={touched.accountNo && errors.accountNo ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input"
                                                name="accountNo"
                                                placeholder={FIELDS.account_no.placeholder || "Enter Account No"}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.accountNo && errors.accountNo ? (
                                                <div className="error-msg">
                                                    {errors.accountNo}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                                <FormUi.Field width={1}></FormUi.Field>

                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.ifsc_code.title || "IFSC Code"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field width={4} error={touched.ifscCode && errors.ifscCode ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                type="text"
                                                className="ui input"
                                                name="ifscCode"
                                                placeholder={FIELDS.ifsc_code.placeholder || "Enter IFSC Code"}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.ifscCode && errors.ifscCode ? (
                                                <div className="error-msg">
                                                    {errors.ifscCode}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                            </FormUi.Group>

                            <FormUi.Group inline>
                                <FormUi.Field width={3}>
                                    <label className="labelName">
                                        {FIELDS.is_default.title || "Is Default Bank"}
                                    </label>
                                </FormUi.Field>
                                <FormUi.Field error={touched.accountNo && errors.accountNo ? true : false} >
                                    <div className="container">
                                        <div className="row">
                                            <Fieldmik
                                                component={MyNormalCheckBox}
                                                className="ui input"
                                                name="isDefaultBank"
                                                checked={values.isDefaultBank}
                                            />
                                        </div>
                                        <div className="row">
                                            {touched.accountNo && errors.accountNo ? (
                                                <div className="error-msg">
                                                    {errors.accountNo}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </FormUi.Field>
                            </FormUi.Group>
                        </div>
                    </div>
                </div>
                <Container className="p-3" textAlign="center">
                    <button
                        className="w3-button w3-blue w3-hover-blue w3-round w3-small"
                        type="submit"
                    >
                        {"Submit"}
                    </button>
                </Container>
            </Formiker>
        </React.Fragment>
    );
};

const FormikInsertBank = withFormik({
    validationSchema: yup.object({
        bankName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(30, ERROR_MESSAGES.MAX_LENGTH(30)),
        bankCode: yup.string().optional().nullable(),
        accountCode: yup.string().optional().nullable(),
        accountName: yup.string().optional().nullable(),
        accountNo: yup.string().optional().nullable().matches(AllRegex.BankAccNumber, INVALID_FIELDS.INVALID_BANK_ACCOUNT_NO),
        ifscCode: yup.string().optional().nullable().matches(AllRegex.BankIFSCcode, INVALID_FIELDS.INVALID_IFSC_CODE)
    }),
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            bankName: props?.editData?.bankName || "",
            bankCode: props?.editData?.bankCode || "",
            accountCode: props?.editData?.accountCode || "",
            accountName: props?.editData?.accountName || "",
            accountNo: props?.editData?.accountNo || "",
            ifscCode: props?.editData?.ifscCode || "",
            isDefaultBank : props?.editData?.isDefaultBank && props?.editData?.isDefaultBank == 1 ? true :false
        };
    },
    async handleSubmit(values, { props, resetForm }) {

        values.isDefaultBank = values.isDefaultBank ? "1" : "0"
        if (props.editData.bankId) {
            UpdateAxios({
                url: "bank",
                payload: { ...values },
                uniqueId: props.editData.bankId,
            })
                .then((res) => {
                    if (res?.data?.status === 200) {
                        cogoToast.success(res?.data?.message || "Success", { position: 'top-right' });
                        setTimeout(() => {
                            props.onFormSubmit();
                        }, 500);
                    } else {
                        cogoToast.error(res?.data?.message || "Error occured", { position: 'top-right' });
                    }

                })
                .catch((err) => {
                    cogoToast.error(err?.data?.message || "Error occured", { position: 'top-right' });

                });
        } else {
            CreateAxios({
                url: `bank`,
                payload: { ...values },
            })
                .then((res) => {
                    if (res?.data?.status == 200) {
                        cogoToast.success(res?.data?.message || "Success", { position: 'top-right' });
                        setTimeout(() => {
                            props.onFormSubmit();
                        }, 500);
                    } else {
                        cogoToast.error(res?.data?.message || "Error occured", { position: 'top-right' });
                    }
                })
                .catch((err) => {
                    console.log("error bank", err);
                    cogoToast.error(err?.data?.message || "Error occured", { position: 'top-right' });
                });
        }
    },
})(InsertBank);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
    translate("bank")(FormikInsertBank)
);
